export const todayFormat = () => {
  let newDate = new Date()
  let dd = ('0' + newDate.getDate()).slice(-2)
  let mm = ('0' + (newDate.getMonth() + 1)).slice(-2)
  let yyyy = newDate.getFullYear()

  return `${yyyy}-${mm}-${dd}`
}



// WEBPACK FOOTER //
// ./src/services/TodayFormat.js